import './index.less';
import { Form, Radio, Select, Input } from 'antd';
import {
  OrgCsrDTO,
  OrgCsrItemDTO,
  RevshopCsrDisplayForEnum,
} from 'domains/orgDomain';
import RevxFlexLayout from 'components/RevxFlexLayout';
import orgService from 'services/orgService';
import { useOrgId } from 'hooks/useOrg';
import { useState } from 'react';
import { useMount } from 'ahooks';
import RevxTable, { TableColumnsType } from 'components/RevxTable';
import CsrSelect from './components/CsrSelect';
import { useDebounceFn } from 'ahooks';
import { DEBOUNCE_TIME } from 'utils/constants';
import { RevxSpin } from 'components/RevxSpin';
import CsrSpecificProducts from './components/CsrSpecificProducts';

const selectOptions = Object.values(RevshopCsrDisplayForEnum).map((item) => {
  return {
    label: item,
    value: item,
  };
});

const CSRAdminContainer = () => {
  const [orgCsrData, setOrgCsrData] = useState<OrgCsrDTO>();
  const [loading, setLoading] = useState(false);
  const orgId = useOrgId();
  const [csrForm] = Form.useForm();

  useMount(async () => {
    setLoading(true);
    const orgCsr = await orgService.getOrgCsrDisplay(orgId);
    setOrgCsrData(orgCsr);
    csrForm.setFieldsValue(orgCsr);
    setLoading(false);
  });

  const csrDisplayChange = async (v: string) => {
    const orgCsr = await orgService.updateOrgCsrDisplay(orgId, `"${v}"`);
    setOrgCsrData(orgCsr);
    csrForm.setFieldsValue(orgCsr);
  };

  const { run: runUpdateOrgCsrItem } = useDebounceFn(
    async (item: OrgCsrItemDTO) => {
      await updateOrgCsrItem(item);
    },
    {
      wait: DEBOUNCE_TIME,
    }
  );
  const updateOrgCsrItem = async (item: OrgCsrItemDTO) => {
    // setLoading(true);
    const orgCsr = await orgService.updateOrgCsrItem(orgId, item);
    setOrgCsrData(orgCsr);
    // setLoading(false);
  };

  const columns: TableColumnsType<OrgCsrItemDTO> = [
    {
      title: 'Role',
      dataIndex: 'role',
      width: 200,
      render: (value, record, index) => (
        <Form.Item name={['orgCsrItems', index, 'role']}>
          <div>{value}</div>
        </Form.Item>
      ),
    },
    {
      title: 'Display CSR contacts',
      dataIndex: 'display',
      width: 200,
      render: (value, record, index) => (
        <Form.Item name={['orgCsrItems', index, 'display']}>
          <Radio.Group
            onChange={async (v) => {
              await runUpdateOrgCsrItem({ ...record, display: v.target.value });
            }}
          >
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>
      ),
    },
    {
      title: 'Field label',
      dataIndex: 'fieldName',
      width: 400,
      render: (value, record, index) => (
        <>
          {record.display && (
            <Form.Item
              name={['orgCsrItems', index, 'fieldName']}
              rules={[{ required: true, message: '' }]}
            >
              <Input
                placeholder="Provide label here"
                onChange={async (event) => {
                  const v = event.target.value.trim();
                  if (v) {
                    await runUpdateOrgCsrItem({
                      ...record,
                      fieldName: event.target.value,
                    });
                  }
                }}
              />
            </Form.Item>
          )}
        </>
      ),
    },
    {
      title: 'CSR contacts(up to two names)',
      dataIndex: 'csrs',
      render: (value, record, index) => {
        const { display, contacts } = record;
        return (
          <>
            {display && (
              <CsrSelect
                initValue={contacts}
                onChange={async (contacts) => {
                  if (contacts) {
                    await runUpdateOrgCsrItem({
                      ...record,
                      contacts,
                    });
                  }
                }}
              />
            )}
          </>
        );
      },
    },
  ];

  return (
    <div className="csr-admin mt-20">
      <RevxSpin spinning={loading}>
        <Form form={csrForm}>
          <div className="csr-role">
            <RevxFlexLayout className="mb-20">
              <div className="csr-role__label mr-10 bold">
                Users who can see revshop as the CSR contact on the job cards:
              </div>
              <Form.Item name="revshopCsrDisplayFor">
                <Select options={selectOptions} onChange={csrDisplayChange} />
              </Form.Item>
            </RevxFlexLayout>
            <div className="csr-role-tips">
              I want to display CSR contacts for my organization for these
              roles:
            </div>
          </div>
          <div className="csr-display-table">
            <RevxTable
              dataSource={orgCsrData?.orgCsrItems}
              columns={columns}
              pagination={false}
              key="fieldName"
            />
          </div>
        </Form>
        <CsrSpecificProducts
          initValue={orgCsrData?.specialCsrItems}
          setLoading={setLoading}
        />
      </RevxSpin>
    </div>
  );
};
export default CSRAdminContainer;
